import { render, staticRenderFns } from "./groupView.vue?vue&type=template&id=9e566d34&"
import script from "./groupView.vue?vue&type=script&lang=ts&"
export * from "./groupView.vue?vue&type=script&lang=ts&"
import style0 from "./groupView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports